<template>
    <div class="SiteSidebar">
        <div class="header">
            <router-link to="/" class="logoContainer">
                <Logo class="white"/>
            </router-link>
        </div>

        <div class="main">
            <div class="nav">
                <router-link
                    v-for="page in pages"
                    :key="page"
                    :to="`/${page}`"
                >
                    {{ page }}
                </router-link>
            </div>

            <div class="actions">
               <div v-if="user" class="nav">
                    <CompanyLogo nameDisplay="user"/>
                    <router-link to="/company/dashboard">Dashboard</router-link>
                    <router-link to="/company/settings">Settings</router-link>
                    <button class="danger" @click="handleLogout">Log out</button>
                </div>
                <div v-else>
                    <Button to="/login" class="outline white block">Log In</Button>
                    <Button to="/signup" class="white block">Sign Up</Button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Logo from '@/components/Logo';
import CompanyLogo from '@/components/CompanyLogo';

export default {
    name: 'SiteSidebar',

    components: { Logo, CompanyLogo },

    data: () => ({
        pages: [
            'pricing',
            'about',
            'contact',
            'support',
        ],
    }),

    props: {
        user: { type: Object },
    },

    methods: {
        handleLogout() {
            this.$store.dispatch('auth/logout', { redirect: true });
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.SiteSidebar {
    display: flex;
    flex-direction: column;
    background-color: $brand-primary;
    color: #fff;

    .header {
        display: flex;
        justify-content: center;
        flex-shrink: 0;
        width: 100%;
        height: $admin-header-height;
        background-color: rgba(#000, 0.15);

        .logoContainer {
            display: flex;

            .Logo {
                width: 160px;
            }
        }
    }

    .main {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
        margin: 30px 0;
    }

    .nav {
        width: 100%;

        a, button {
            display: block;
            padding: 15px 15px 15px 30px;
            border-left: 5px solid rgba(#fff, 0.1);
            text-transform: capitalize;
            color: #fff;

            &:hover {
                background-color: rgba(#fff, 0.035);
            }

            &.router-link-active {
                border-color: #fff;
                font-weight: $font-weight-bold;
            }
        }

        button {
            width: 100%;
            appearance: none;
            background-color: transparent;
            border-top: none;
            border-bottom: none;
            border-right: none;
            font-size: inherit;
            text-align: inherit;
            cursor: pointer;
        }
    }

    .actions {
        width: 100%;
        align-self: flex-end;
        padding: 0 $grid-gutter-width;

        .Button + .Button {
            margin-top: $grid-gutter-width;
        }
    }

    .CompanyLogo {
        margin-bottom: $grid-gutter-width;
    }
}
</style>
